import { emitGlobalToast } from "../../components/common/Toast";
import { queryClient } from "../../lib/queryClient";
import { API, fetchJson, invalidatePolicyQueries } from "./policyApi/shared";
import { publishPolicyUploadRefresh } from "./policyUploadRefresh";

export type ReprocessReceipt = { queued?: boolean; total?: number; uploadIds?: number[]; groupJobId?: number };
const watching = new Set<string>();
/** 접수한 일감이 있을 때만 조회하고, 완료·실패 뒤에는 조회를 멈춘다. */
export function announceReprocessing<T extends ReprocessReceipt>(receipt: T): T {
  if (!receipt.queued) return receipt;
  void queryClient.invalidateQueries({ queryKey: ["policy", "reprocess-status"] });
  const params = new URLSearchParams();
  if (receipt.groupJobId) params.set("groupJobId", String(receipt.groupJobId));
  else params.set("uploadIds", (receipt.uploadIds ?? []).join(","));
  const key = params.toString();
  emitGlobalToast("info", `처리 중 ${receipt.total ?? 0}건 — 다른 화면을 계속 사용하실 수 있습니다`);
  if (watching.has(key)) return receipt;
  watching.add(key);
  const check = async () => {
    if (document.hidden) { window.setTimeout(() => void check(), 5000); return; }
    try {
      const state = await fetchJson<{ pending: number; failures: string[] }>(`${API}/reprocess-status?${params}`);
      if (state.pending > 0) { window.setTimeout(() => void check(), 3000); return; }
      watching.delete(key);
      await invalidatePolicyQueries(queryClient);
      for (const id of receipt.uploadIds ?? []) publishPolicyUploadRefresh(id);
      if (state.failures.length) emitGlobalToast("error", `재처리 실패: ${state.failures.join(" · ")}`);
      else emitGlobalToast("success", "재처리를 마쳤습니다. 시세표에 반영했습니다");
    } catch {
      watching.delete(key);
      emitGlobalToast("info", "처리 상태를 확인하지 못했습니다. 정책표 처리 내역에서 확인해 주세요");
    }
  };
  window.setTimeout(() => void check(), 1000);
  return receipt;
}
